var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "toparrowIcon",
    "data-name": "rightarrowIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.2666 47.2467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M47.2567,23.6381a1,1,0,0,1-1.707.707L23.63,2.4251,1.71,24.3451a1,1,0,1,1-1.4386-1.39l.0246-.0245L22.9216.3036A.9991.9991,0,0,1,24.3344.3024h0l.0011.0011L46.9638,22.9309A1,1,0,0,1,47.2567,23.6381Z",
    transform: "translate(0.01 -0.0104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M24.63,1.02V46.2571a1,1,0,0,1-2,0V1.02a1,1,0,0,1,2,0Z",
    transform: "translate(0.01 -0.0104)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToparrow);
export default __webpack_public_path__ + "static/media/toparrow.5fa21cfb.svg";
export { ForwardRef as ReactComponent };